/* RHÔME — filtrage, tri et tiroir de la page collection */
(function () {
  'use strict';

  var LABELS = {
    genre: { homme: 'Homme', femme: 'Femme' },
    prix: {},
    couleur: { noir: 'Noir', marron: 'Marron', tabac: 'Tabac', kaki: 'Kaki', blanc: 'Blanc', dore: 'Doré', nude: 'Nude', imprime: 'Imprimé' },
    type: {},
    matiere: { lisse: 'Cuir lisse', verni: 'Cuir verni', imprime: 'Cuir imprimé' },
    taille: {}
  };

  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function boot(scope) {
    var grid = scope.querySelector('[data-rh-grid]');
    if (!grid) return;
    var root = grid.closest('.rh');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.rh-card'));
    var guide = grid.querySelector('.rh-guide');
    var chips = root.querySelector('[data-rh-chips]');
    var cntEl = root.querySelector('[data-rh-count]');
    var shownEl = root.querySelector('[data-rh-shown]');
    var barEl = root.querySelector('[data-rh-bar]');
    var sortEl = root.querySelector('[data-rh-sort]');

    function inputs() { return Array.prototype.slice.call(root.querySelectorAll('input[data-rh-f]')); }

    function active() {
      var a = {};
      inputs().forEach(function (i) {
        if (!i.checked) return;
        (a[i.getAttribute('data-rh-f')] = a[i.getAttribute('data-rh-f')] || []).push(i.value);
      });
      return a;
    }

    function matches(card, a) {
      for (var key in a) {
        var vals = a[key];
        if (!vals.length) continue;
        if (key === 'taille') {
          var have = (card.getAttribute('data-tailles') || '').split(',');
          if (!vals.some(function (v) { return have.indexOf(v) > -1; })) return false;
        } else if (key === 'prix') {
          if (vals.indexOf(card.getAttribute('data-band')) === -1) return false;
        } else {
          if (vals.indexOf(card.getAttribute('data-' + key)) === -1) return false;
        }
      }
      return true;
    }

    function renderChips(a) {
      if (!chips) return;
      chips.innerHTML = '';
      var total = 0;
      Object.keys(a).forEach(function (key) {
        a[key].forEach(function (v) {
          total++;
          var label = (LABELS[key] && LABELS[key][v]) || (key === 'taille' ? 'Pointure ' + v : cap(v));
          var el = document.createElement('span');
          el.className = 'rh-chip';
          el.innerHTML = label + ' <button type="button" aria-label="Retirer ce filtre">&times;</button>';
          el.querySelector('button').onclick = function () {
            inputs().forEach(function (i) {
              if (i.getAttribute('data-rh-f') === key && i.value === v) i.checked = false;
            });
            apply();
          };
          chips.appendChild(el);
        });
      });
      if (total > 1) {
        var all = document.createElement('span');
        all.className = 'rh-chip';
        all.innerHTML = 'Tout effacer <button type="button" aria-label="Tout effacer">&times;</button>';
        all.querySelector('button').onclick = clear;
        chips.appendChild(all);
      }
    }

    function sortGrid() {
      var v = sortEl ? sortEl.value : 'reco';
      var list = cards.slice();
      list.sort(function (x, y) {
        var px = parseFloat(x.getAttribute('data-prix')) || 0;
        var py = parseFloat(y.getAttribute('data-prix')) || 0;
        if (v === 'asc') return px - py;
        if (v === 'desc') return py - px;
        if (v === 'promo') return (+y.getAttribute('data-remise')) - (+x.getAttribute('data-remise'));
        if (v === 'new') return (+y.getAttribute('data-new')) - (+x.getAttribute('data-new')) || (+x.getAttribute('data-reco')) - (+y.getAttribute('data-reco'));
        return (+x.getAttribute('data-reco')) - (+y.getAttribute('data-reco'));
      });
      list.forEach(function (c) { grid.appendChild(c); });
      if (guide) {
        var visible = list.filter(function (c) { return !c.classList.contains('is-hidden'); });
        if (visible.length > 8) grid.insertBefore(guide, visible[8]);
        else grid.appendChild(guide);
      }
      var e = grid.querySelector('.rh-empty');
      if (e) grid.appendChild(e);
    }

    function apply() {
      var a = active();
      var n = 0;
      cards.forEach(function (c) {
        var ok = matches(c, a);
        c.classList.toggle('is-hidden', !ok);
        if (ok) n++;
      });
      if (cntEl) cntEl.textContent = n;
      if (shownEl) shownEl.textContent = n;
      if (barEl) barEl.style.width = (cards.length ? (n / cards.length) * 100 : 0) + '%';
      if (guide) guide.style.display = n === 0 ? 'none' : '';
      var old = grid.querySelector('.rh-empty');
      if (old) old.remove();
      if (n === 0) {
        var e = document.createElement('div');
        e.className = 'rh-empty';
        e.innerHTML = '<h3>Aucun modèle ne correspond</h3><p>Essayez d\'élargir votre sélection, ou effacez un filtre.</p>';
        grid.appendChild(e);
      }
      renderChips(a);
      sortGrid();
    }

    function clear() {
      inputs().forEach(function (i) { i.checked = false; });
      apply();
    }

    root.querySelectorAll('[data-rh-acc]').forEach(function (b) {
      b.onclick = function () { b.parentElement.classList.toggle('is-open'); };
    });
    inputs().forEach(function (i) { i.addEventListener('change', apply); });
    if (sortEl) sortEl.addEventListener('change', sortGrid);
    var clr = root.querySelector('[data-rh-clear]');
    if (clr) clr.onclick = clear;

    var scrim = root.querySelector('[data-rh-scrim]');
    var drawer = root.querySelector('[data-rh-fdrawer]');
    var panel = root.querySelector('[data-rh-fpanel]');
    var filters = root.querySelector('[data-rh-filters]');
    var openBtn = root.querySelector('[data-rh-openf]');
    function close() {
      if (drawer) drawer.classList.remove('is-on');
      if (scrim) scrim.classList.remove('is-on');
    }
    if (openBtn && drawer && panel && filters) {
      openBtn.onclick = function () {
        if (!panel.childElementCount) panel.appendChild(filters);
        drawer.classList.add('is-on');
        if (scrim) scrim.classList.add('is-on');
      };
    }
    root.querySelectorAll('[data-rh-closef]').forEach(function (b) { b.onclick = close; });
    if (scrim) scrim.onclick = close;
    var clrM = root.querySelector('[data-rh-clearm]');
    if (clrM) clrM.onclick = clear;

    apply();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-rh-grid]').forEach(function (g) { boot(g.closest('.rh') || scope); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
